import { useMemo } from 'react';

import dateFormat from 'dateformat';

import { BootstrapTable } from '@components/Table/Table';

export const OutboundTariffTable = ({ data, isLoading }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Country',
        accessor: 'country',
      },
      {
        Header: 'Destination',
        accessor: 'destination',
      },
      {
        Header: 'LT Plan',
        accessor: 'lt_plan',
      },
      {
        Header: 'PSTN Plan',
        accessor: 'pstn_outbound_plan',
      },
      {
        Header: 'Date withdrawn',
        accessor: 'date_withdrawn',
        Cell: ({ value }) => {
          if (!value) {
            return null;
          }
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
        setMinWidth: '90px',
      },
      {
        Header: 'Call setup',
        accessor: 'setup_cost',
      },
      {
        Header: 'Price Per Minute',
        accessor: 'price_per_minute',
      },
      {
        Header: 'Currency Traffic',
        accessor: 'currency_traffic',
      },
      {
        Header: 'Billing Method',
        accessor: 'billing_method',
      },
      {
        Header: 'Date Active',
        accessor: 'date_active',
        Cell: ({ value }) => {
          if (!value) {
            return null;
          }
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
        setMinWidth: '90px',
      },
      {
        Header: 'Change',
        accessor: 'description',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        striped: true,
        className: 'normalFontSize',
      })}
      isLoading={isLoading}
    />
  );
};
